import * as Sentry from "@sentry/react";

export function setSentryUser(user: { id: string; email: string | undefined }) {
  Sentry.setUser({ id: user.id, email: user.email });
}

export function clearSentryUser() {
  Sentry.setUser(null);
}
